import React from "react";
import { usePFDataContext } from '../context/PfContext';

const Alert = () => {
    const { alertMessage } = usePFDataContext();

    // Style object for the alert box
    const alertStyles = {
        position: 'fixed',
        top: '20%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#f8d7da',
        color: '#721c24',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 9999,
        textAlign: 'center',
        maxWidth: '300px',
        fontFamily: 'Arial, sans-serif',
        fontSize: '16px',
    };

    return (
        alertMessage && (
            <div style={alertStyles}>
                {alertMessage}
            </div>
        )
    );
}

export default Alert;
